import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <>
      <div className="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="footer-text-cover">
                <div className="copyright-text">
                  Copyright © {(new Date().getFullYear())} Visionary Technologies, LLC. All Rights Reserved
                    </div>
                <ul className="footer-list">
                  <li>
                    <Link to='/teacher-faq'>FAQ's</Link>
                  </li>
                  <li>
                    <Link to='/page/terms-and-conditions'>Terms & Condition</Link>
                  </li>
                  {/* <li>
                    <Link to='/ns/ABRTL-WEB/teacher-contactus'>Contact Us</Link>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}


